export const SidebarIdSpaceAgents = 'SPACE_AGENTS' as const;
